import React from 'react'

export default function SvgCheckmark() {
  return (
    <>
        <svg 
            className='wth3-radioCheckmark' 
            viewBox='0 0 24 24' 
            fill='none' 
            stroke='black' 
            strokeWidth="3" 
            strokeLinecap='round' 
            strokeLinejoin='round' 
        >
            <polyline points="20 6 9 17 4 12" />
        </svg>
    </>
  )
}
